<h1 class="header mat-typography">Anhänge</h1>
<app-timeslot-detail-attachment-list [timeslotId]="timeslot.id"></app-timeslot-detail-attachment-list>
